<template>
  <div class="main">
    <div class="list-bg"><img :src="bkimg" alt=""></div>
    <div class="contain">
      <div class="navigate pointer">
        <span :class='{"lastnav":index==navigate.length-1}' v-for='(nav,index) in navigate' :key='index' @click='goto(index)'>{{nav}}<span class='lastnav' v-show='index != navigate.length-1'>></span></span>
      </div>
      <div class="alltrip" style='display:none'>
        <div class="flex">
          <span class='triptxt'>行 &nbsp; &nbsp;程</span>
          <div class="inputDown">
            <div class="input flex align-items justify-content" @click='selecttrip'>
              <p class='inputcontent'>{{trip.name}}</p>
              <div class="tridown">
                <img src="../static/images/down.jpg" alt="">
              </div>
            </div>
            <div class="down" v-show='tripshow'>
              <div :class='["sel",{active:trip.active}]' v-for='(trip,index) in trips' :key='index' @click='choosetrip(index)'> {{trip.name}} </div>
            </div>
          </div>
          <span class='triptxt mg20'>旅行方式</span>
          <div class="inputDown">
            <div class="input flex align-items justify-content triptype" @click='selecttype'>
              <p class='inputcontent'>{{triptype.name}}</p>
              <div class="tridown">
                <img src="../static/images/down.jpg" alt="">
              </div>
            </div>
            <div class="down triptype" v-show='typeshow'>
              <div :class='["sel1",{active1:trip.active}]' v-for='(trip,index) in triptypes' :key='index' @click='choosetype(index)'> {{trip.name}} </div>
            </div>
          </div>
          <span class='triptxt mg20'>最早出发</span>
          <div class="inputDown">
            <div class="input flex align-items justify-content triptime" @click='selectstarttime'>
              <p class='inputcontent'>{{starttime}}</p>
              <div class="tridown">
                <img class='date' src="../static/images/date.jpg" alt="">
              </div>
            </div>
            <div class="down time" v-show='starttimeshow'>
              <Calendar
                  ref="Calendar"
                  v-on:choseDay="choosestarttime"
                ></Calendar>
            </div>
          </div>
          <span class='triptxt mg20'>最晚出发</span>
          <div class="inputDown">
            <div class="input flex align-items justify-content triptime" @click='selectendtime'>
              <p class='inputcontent'>{{endtime}}</p>
              <div class="tridown">
                <img class='date' src="../static/images/date.jpg" alt="">
              </div>
            </div>
            <div class="down time" v-show='endtimeshow'>
              <Calendar
                  ref="Calendar"
                  v-on:choseDay="chooseendtime"
                ></Calendar>
            </div>
          </div>
        </div>
        <div class="flex align-items" style='margin-top:20px;'>
          <span class='triptxt triptx1'>关键词</span>
          <div class="inputDown" style='z-index:0'>
            <input type="text" class="input inputcontent1" v-model='keyword'>
          </div>
          <div class="btn" @click='search'>搜索</div>
        </div>
      </div>
      <div class="boat">
        <div class="title">{{luxuryboats.name}}</div>
        <div class="flex">
          <div class="largepic" v-for='(pic,index) in largepics' :Key='index' @mouseenter="enter(index)" @mouseleave="leave()" @click='gotosteamerTicket(pic.id,pic.name,pic.img)'>
            <img class='large' :src="pic.img" alt="">
            <div class="word">
              <div class="word-title">
                <p class='name'>
                  <span>{{pic.name}}</span><span>({{pic.capacity}}人)</span>
                </p>
                <p class='descript'>{{pic.detail}}</p>
              </div>
                <img class='jt' src="../static/images/jt.png" alt="">
            </div>
            <div class="flex btompic" v-show='pic.mounseenter'>
                  <div class="littlepic" v-for='(little,index1) in pic.hover' :key='index1'>
                    <img class='littleimg' src="../static/images/b2.jpg" alt="">
                    <img class='mjt' src="../static/images/jt.png" alt="">
                    <div :class="{btomword :index1==0,bword:index1==1 }">
                        <p class='name'>
                          <span>{{little.name}}</span><span>({{little.person}}人)</span>
                        </p>
                        <p class='descript'>{{little.descript}}</p>
                    </div>

                  </div>
              </div>
            <div class="bk" v-show='pic.mounseenter'>
            </div>
          </div>
        </div>
        <boat :boatitems ='littlepics'></boat>
        <div class="title">{{explore.name}}</div>
        <boat :boatitems ='eitems'></boat>
      </div>
      <!-- <p class='more' @click='more'>点击加载更多</p>
      <vuePagition :total =20></vuePagition> -->
    </div>
  </div>
</template>
<script>
import Calendar from '../components/vue-calendar-component/index'
import {shiptype, shiplist} from '@/api/ship.js'
import vuePagition from '../components/vue-pagition/vue-pagition'
import boat from '@/components/boat/boat.vue'
export default {
  components: {
    Calendar, vuePagition, boat
  },
  data () {
    return {
      navigate: ['首页', '南极船票预定'],
      trip: {},
      trips: [{name: '南极半岛', active: false, id: 0}, {name: '南极圈', active: false, id: 1}],
      tripshow: false,
      triptype: {},
      triptypes: [{name: '船去船回', active: false, id: 0}, {name: '空海航运', active: false, id: 1}],
      typeshow: false,
      starttimeshow: false,
      starttime: '',
      endtimeshow: false,
      endtime: '',
      keyword: '',
      luxuryboats: {
        // title: '豪华探险船',
        // largepics: [
        //   {
        //     url: '',
        //     name: '海报舰号',
        //     person: 110,
        //     descript: '提供五星级住宿,四星级餐饮',
        //     mounseenter: false,
        //     hover: [
        //       {
        //         url: '',
        //         name: '海报舰号',
        //         person: 110,
        //         descript: '提供五星级住宿,四星级餐饮'
        //       },
        //       {
        //         url: '',
        //         name: '海报舰号',
        //         person: 110,
        //         descript: '提供五星级住宿,四星级餐饮'
        //       }
        //     ]
        //   },
        //   {
        //     url: '',
        //     name: '海报舰号',
        //     person: 110,
        //     descript: '提供五星级住宿,四星级餐饮',
        //     mounseenter: false,
        //     hover: [
        //       {
        //         url: '',
        //         name: '海报舰号',
        //         person: 110,
        //         descript: '提供五星级住宿,四星级餐饮'
        //       },
        //       {
        //         url: '',
        //         name: '海报舰号',
        //         person: 110,
        //         descript: '提供五星级住宿,四星级餐饮'
        //       }
        //     ]
        //   }
        // ],
        // littlepics: [
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   },
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   },
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   },
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   }
        // ]
      },
      explore: {
        // title: '探险船',
        // items: [
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   },
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   },
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   },
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   },
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   },
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   },
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   },
        //   {
        //     url: '',
        //     name: '星辰号',
        //     person: 80,
        //     descript: '提供五星级住宿,最现代且设施完善的海洋探险船之一'
        //   }
        // ]
      },
      eitems: [],
      largepics: [],
      littlepics: [],
      querylist: {
        name: ''
      },
      bkimg: ''
    }
  },
  mounted () {
    this.bkimg = this.$route.query.img
    if (this.$route.query.name) {
      this.navigate[1] = this.$route.query.name
    }
    if (this.$route.query.id) {
      this.querylist.menuId = this.$route.query.id
    }
    this.trip = this.trips[0]
    this.triptype = this.triptypes[0]
    this.getshiptypelist()
  },
  methods: {
    goto (index) {
      if (index === 0) {
        this.$router.push({path: '/index'})
      }
    },
    // 选中某天
    clickDay (data) {
      console.log('选中了', data)
    },
    // 弹出行程选择框
    selecttrip () {
      for (let i = 0; i < this.trips.length; i++) {
        this.trips[i].active = false
        if (this.trips[i].id === this.trip.id) {
          this.trips[i].active = true
        }
      }
      this.tripshow = !this.tripshow
      this.typeshow = false
      this.starttimeshow = false
      this.endtimeshow = false
    },
    // 选择行程
    choosetrip (index) {
      this.trip = this.trips[index]
      for (let i = 0; i < this.trips.length; i++) {
        this.trips[i].active = false
      }
      this.trips[index].active = true
      this.tripshow = false
    },
    // 弹出旅行方式选择框
    selecttype () {
      for (let i = 0; i < this.triptypes.length; i++) {
        this.triptypes[i].active = false
        if (this.triptypes[i].id === this.triptype.id) {
          this.triptypes[i].active = true
        }
      }
      this.typeshow = !this.typeshow
      this.tripshow = false
      this.starttimeshow = false
      this.endtimeshow = false
    },
    // 选择旅行方式
    choosetype (index) {
      this.triptype = this.triptypes[index]
      for (let i = 0; i < this.triptypes.length; i++) {
        this.triptypes[i].active = false
      }
      this.triptypes[index].active = true
      this.typeshow = false
    },
    formattime (date) {
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      let a = date.getDay()
      let day = ['日', '一', '二', '三', '四', '五', '六']
      return `${y}-${m}-${d}(周${day[a]})`
    },
    // 弹出最早时间选择框
    selectstarttime () {
      this.starttimeshow = !this.starttimeshow
      this.tripshow = false
      this.typeshow = false
      this.endtimeshow = false
    },
    // 选择最早时间
    choosestarttime (data) {
      this.starttime = this.formattime(new Date(data))
      this.starttimeshow = false
    },
    // 弹出最晚时间选择框
    selectendtime () {
      this.endtimeshow = !this.endtimeshow
      this.tripshow = false
      this.typeshow = false
      this.starttimeshow = false
    },
    // 选择最晚时间
    chooseendtime (data) {
      this.endtime = this.formattime(new Date(data))
      this.endtimeshow = false
    },
    // 搜索
    search () {

    },
    // 鼠标移入大图
    enter (index) {
      // this.leave()
      // this.luxuryboats.largepics[index].mounseenter = true
    },
    leave () {
      // for (let i = 0; i < this.luxuryboats.largepics.length; i++) {
      //   this.luxuryboats.largepics[i].mounseenter = false
      // }
    },
    // 加载更多
    more () {

    },
    getshiptypelist () {
      shiptype().then(res => {
        this.luxuryboats = res.data.data.items[0]
        this.getlist(this.luxuryboats.id)
        this.explore = res.data.data.items[1]
        this.getlist(this.explore.id)
      })
    },
    getlist (id) {
      let data = {name: this.querylist.name}
      data.shipTypeId = id
      data.menuId = this.querylist.menuId
      shiplist(data).then(res => {
        let items = res.data.data.items
        if (id === this.luxuryboats.id) {
          if (items.length > 2) {
            this.largepics = items.slice(0, 2)
            this.littlepics = items.slice(2, items.length)
            console.log(this.luxuryboats)
          } else {
            this.largepics = items
          }
        } else if (id === this.explore.id) {
          this.eitems = items
        }
      })
    },
    // 跳转详情页
    gotosteamerTicket (id, name, img) {
      this.$router.push({
        path: '/steamerTicket',
        query: {
          id: id,
          name: name,
          img: img
        }
      })
    }
  },
  created () {
  }
}
</script>
<style lang="scss" scoped>
  .main{
      background-color:#f4f4f4;
      padding-bottom:40px;
  }
  .pointer{
    cursor: pointer;
  }
  .ivu-select-dropdown {
      margin: 0 !important;
      border-radius: 0px !important;
  }
  .contain{
    width:80rem;
    background-color: #fff;
    padding-bottom:3.75rem;
    margin: -200px auto 0;
        position: relative;
  }
  .list-bg {
        width: 100%;
        height: 672px;
        background: url(../static/images/bj.png) no-repeat center;
        background-size: cover;
    }
  .list-bg img{
    width:100%;
  }
  .navigate{
    height:3.75rem;
    text-align:left;
    color:#0080cc;
    font-size:.875rem;
    line-height:3.75rem;
    padding-left:1.5rem;
    border-bottom:1px solid #dae1e6;
  }
  .navigate span{
    margin-left:.3125rem;
  }
  .lastnav{
    color:#60676d;
  }
  .alltrip{
    padding:1.5rem;
    border-bottom:1px solid #dae1e6;
  }
   .flex{
    display:flex;
  }
  .align-items{
    align-items: center;
  }
  .justify-content{
    justify-content: space-between;
  }
  .flex-wrap{
    flex-wrap:wrap;
  }
  .input{
    width:15.5rem;
    height:1.875rem;
    border:1px solid #c6cbd0;
    margin-left:.625rem;
    color:#c6c8ca;
  }
  .tridown{
    width:2rem;
    height:100%;
    background-color:#f5f8fa;
    border-left:1px solid #c6cbd0;
    display:flex;
    align-items: center;
  }
  .tridown img{
    width:.4375rem;
    height:.375rem;
    margin:auto;
  }
  .tridown .date{
    width:1rem;
    height:.9375rem;
    margin:auto;
  }
  .inputcontent{
    padding:.625rem;
    font-size:.875rem;
    color:#c6c8ca;
  }
   .inputcontent1{
     width:14.875rem;
    padding-left: .625rem;
    font-size:.875rem;
    color:#c6c8ca;
    line-height: 1.875rem;
  }
  .triptxt{
    color:#6a7176;
    font-size:1rem;
    padding-top:4px;
  }
  .triptx1{
    padding-top:0;
  }
  .inputDown{
    position: relative;
    z-index:999
  }
  .down{
    position: absolute;
    left:0.625rem;
    top:1.875rem;
    width:15.5rem;
    z-index:9999;
    background-color: #fff;
  }
  .sel{
    width:100%;
    height:2.9375rem;
    line-height: 2.9375rem;
    text-align:center;
    color:#9aa2aa;
    font-size:14px;
    border:1px solid #c6cbd0;
  }
  .active{
    background-color: #0080cc;
    color:#fff;
  }
  .mg20{
    margin-left:1rem;
  }
  .triptype{
    width:13.4375rem;
    border:1px solid #c6cbd0;
  }
   .sel1{
    width:90%;
    height:2.9375rem;
    line-height: 2.9375rem;
    margin:auto;
    text-align:center;
    color:#9aa2aa;
    font-size:14px;
    border-bottom:1px solid #c6cbd0;
    border-top:0;
  }
    .sel1:nth-last-child(1){
    border-bottom:0px solid #c6cbd0;
  }
  .active1{
    background-color: #0080cc;
    color:#fff;
    width:100%
  }
  .time{
    width:21.25rem;
  }
  .triptime{
    width:13.4375rem;
  }
  .btn{
    width:5.25rem;
    height:2.125rem;
    line-height: 2.125rem;
    text-align: center;
    margin-left:.625rem;
    background-color: #0080cc;
    color:#fff;
    border-radius: .25rem;
    font-size:.875rem;
  }
  .largepic{
    cursor: pointer;
    width:38.5rem;
    height:31.375rem;
    position: relative;
  }
  .largepic .large{
    width:100%;
    height:100%;
  }
  .boat{
    padding:0 1.5rem;
  }
  .boat .title{
    font-size:1.5rem;
    color:#3f464c;
    margin:1.875rem 0 1.875rem 0;
  }
  .word{
    color:#fff;
    position: absolute;
    top:1.6875rem;
    left:1.25rem;
  }
  .word-title {
    width: 90%;
    background: rgba(0, 0, 0, 0.3);
    padding: 10px 20px 20px 20px;
  }
  .word p{
    margin:0;
    padding:0;
  }
  .word .name span:nth-child(1){
    font-size:1.625rem;
  }
  .word .name span:nth-child(2){
    font-size:1.125rem;
        margin-top: 6px;
        margin-left:10px;
    display: inline-block;
  }
  .word .descript{
    font-size:1rem;
    margin-top:15px;
    // padding-bottom:20px;
  }
  .word .jt{
    margin-top:24rem;
    width:2.125rem;
    height:.875rem;
  }
  .bk{
    position: absolute;
    width:38.5rem;
    height:31.375rem;
    top:0;
    left:0;
    background-color:rgba(0, 0, 0, .5);
  }
  .btompic{
    position: absolute;
    left:0;
    bottom:0;
  }
  .littlepic{
    width:19.25rem;
    height:15.6875rem;
    color:#fff;
    position: relative;
  }
  .littlepic .littleimg{
    width:100%;
    height:100%
  }
  .littlepic p{
    margin:0;
    padding:0;
  }
  .littlepic .name span:nth-of-type(1){
    font-size:1.625rem;
  }
  .littlepic .name span:nth-of-type(2){
    font-size:1.125rem;
  }
  .littlepic .descript{
    font-size:1rem;
    margin-top:.5rem;
  }
  .littlepic .jt{
    margin-top:24rem;
    width:2.125rem;
    height:.875rem;
  }
  .bword{
    position: absolute;
    top:1.25rem;
    left:1.25rem;
  }
  .btomword{
    position: absolute;
    bottom:1.25rem;
    left:1.25rem;
  }
  .mjt{
    width:2.125rem;
    height:.875rem;
    position: absolute;
    right:1.25rem;
    top:-2.125rem;
  }
  .starboat {
    width:18.125rem;
    border:1px solid #e8e8e8;
    padding-bottom:1.25rem;
    margin-top:24px;
    margin-right:20px;
    &:hover {
        box-shadow: 0px 0px 12px #ccc9c9;
        transition: all 0.2s;
        transform: scale(1.02);
    }
  }
  .starboat:nth-of-type(4n+4){
    margin-right:0;
  }
  .starboat img{
    width:100%;
    height:16.625rem;
  }
  .starboat .name{
    font-size:18px;
    color:#434343;
    margin-top:1.25rem;
    margin-left:1.25rem;
  }
  .starboat .descript{
    font-size: 14px;
    color:#7a7a7a;
    margin-top:.5rem;
    margin-left:1.25rem;
  }
  .more{
    font-size: .875rem;
    color:#6a7176;
    font-style:italic;
    text-align: center;
    margin-top:5.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/antarcticShipBooking.vue